<template>
  <footer :class="footerClass()">
    <div
        class="site-footer px-6 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-300 py-4"
    >
      <div class="grid md:grid-cols-2 grid-cols-1 md:gap-5">
        <div class="text-center ltr:md:text-start rtl:md:text-right text-sm">
          {{ $t('message.copyright') }}
        </div>
        <div class="ltr:md:text-right rtl:md:text-end text-center text-sm">
          <a
              :href="dashboardUrl"
              target="_blank"
              class="text-primary-500 font-semibold"
          >
            {{ $t('message.siteName') }}
          </a>
          {{ packageJson.version }}
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import {config} from "@/config.js"
import packageJson from "/package.json";
import {useThemeSettingsStore} from "@/stores/themeSettings";

export default {
  setup() {
    const themeSettingsStore = useThemeSettingsStore()
    const dashboardUrl = import.meta.env.VITE_DASHBOARD_BASE_URL;
    function footerClass() {
      switch (themeSettingsStore.footerType) {
        case "sticky":
          return "sticky bottom-0 z-[999]";
        case "static":
          return "static";
        case "hidden":
          return "hidden";
      }
    }


    return {
      footerClass,
      config,
      packageJson,
      dashboardUrl
    }
  }
};
</script>
<style lang=""></style>
